<template>
    <DataTable
        id="loginHistory"
        orderBy="id"
        orderDir="desc"
        :url="url"
        :columns="columns"
        :searchingEnabled="false"
        :hideTableActions="true"
    />
</template>

<script setup lang="ts">
import moment from "moment";
import DataTable from "../../datatable/DataTable.vue";
import { ref, computed } from "vue";
import useDates from "@/libs/dates/useDates";

moment.updateLocale("en", {
    invalidDate: "No date logged"
});

const { format } = useDates();

const props = defineProps<{
    user_id: number;
}>();

const columns = ref([
    { data: "id" },
    { data: "user_agent" },
    { data: "login_at", render: (row: string) => format(row, "MM/DD/YYYY HH:mm:ss") },
    { data: "logout_at", render: (row: string) => row ? format(row, "MM/DD/YYYY HH:mm:ss") : "--" }
]);

const url = computed(() => `/api/users/${props.user_id}/history/datatable`);
</script>